import { css } from '@emotion/react';

export const PlaceholderMixin = css`
  &::placeholder {
    color: var(--placeholder-color);
    font-size: var(--h5-h6-base-font-size);
  }
`;
